export enum ProgramClassPaperAssessmentsOrderingEnum {
  Name = 'Name',
  Created = 'Created',
}
